import { useQuery } from "@tanstack/react-query";
import { formatFilters } from "PFApp/use_filtered_collection";
import { bookingApprovalsKeys } from "PFCore/hooks/queries/bookings/approvals/query_keys";
import { useState } from "react";

import { fetchBookingApprovals } from "../../services/api";

const initialData = { total: null, pending: null, approved: null, rejected: null };

const useApprovalsCounters = (filters, enabled = true) => {
  const [cache, setCache] = useState(null);

  const { data } = useQuery(
    bookingApprovalsKeys.counters(filters),
    async () => {
      const data = await fetchBookingApprovals({ ...formatFilters({ filters }), page: 1, per_page: 0 });
      const { meta } = data;
      return { ...meta.counters.booking_approvals_state_tally, total: meta.total };
    },
    {
      onSuccess: (counters) => {
        setCache(counters);
      },
      enabled
    }
  );

  return data || cache || initialData;
};

export default useApprovalsCounters;
